import { render, staticRenderFns } from "./AddCareCommunity.vue?vue&type=template&id=7cd34476&scoped=true&"
import script from "./AddCareCommunity.vue?vue&type=script&lang=js&"
export * from "./AddCareCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd34476",
  null
  
)

export default component.exports